export { Captions } from './captions';
export type { CaptionsProps } from './captions';
